import A11yTabs from "a11y-tabs";

class TabBlocks {
    constructor(el) {
        this.el = el;

        this.selectedTab = 0;

        this.firstTabList = this.el.querySelector(`[data-tablist-class]`);
        this.firstPanelsSelector = this.el.querySelector(
            `[data-tab-panel-class]`,
        );

        this.tabListSelector =
            this.firstTabList?.getAttribute("data-tablist-class");

        this.panelSelector = this.firstPanelsSelector?.getAttribute(
            "data-tab-panel-class",
        );

        if (this.tabListSelector && this.panelSelector) {
            this.a11yTabs = new A11yTabs(
                `.${this.tabListSelector}`,
                `.${this.panelSelector}`,
                this.selectedTab,
            );
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const tabBlocks = document.querySelectorAll(
        `[data-people-block], [data-events-recommendations-block]`,
    );

    if (tabBlocks) {
        tabBlocks?.forEach((block) => {
            new TabBlocks(block);
        });
    }
});

export default TabBlocks;
